import { Box } from "@mui/material";

type PlaceHolderImageProps = {
    width?: string | number;
    height?: string | number;
}

const PlaceHolderImage = ({ width = 300, height = 200 }: PlaceHolderImageProps) => {
    return (
        <Box component="svg"
            width={width}
            height={height}
            viewBox="0 0 300 200"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ background: theme => theme.palette.grey[200] }}
        >
            <Box component="text"
                x="50%"
                y="52%"
                dominantBaseline="middle"
                textAnchor="middle"
                sx={{
                    fill: theme => theme.palette.grey[600],
                    fontSize: theme => theme.typography.h6.fontSize
                }}
            >
                Project Placeholder
            </Box>
        </Box>
    );
};

export default PlaceHolderImage;
